module.exports = __webpack_public_path__ + "static/media/target_lv_10f6bd2936dcd7af6ca93afcc29caf06a9.webp";